export default __webpack_public_path__ + "static/media/login-step.b99b70e1.svg";